module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAaCAYAAAC6nQw6AAABF0lEQVRIS+2VsUoDQRRF750dKz9AG0H8glRil0p709mLRlD8Ai20SWcRZWPwAyzEtdYqlYuNFv6BlR9g5e5cGQm6MTsJC1ZhpxrmvXse7zHcxzhOlj8tryg0AVhUO5mIwVymbXb7d48A1v7q5VwjyrP34nse2QUa81JSK/UgB4BjQeENxMfIuzAPYqkEJA+SDzihA7lBlc6MMSsALrzmFwS3dbjTuq4COusnDQs+16Dw1OoZTf9R9YxmZkYCbki+Tm+okCEtAmiP2EglQEnyj7FNAKXD2JivFzWTQdLpwe7msRd0L5MTkEehgmHz9z7s3MZ+u/Xgxee923UZcx8AfZt/6ToaCp4y5Xv+bhnFAFYDoJT/tSC/ADl88UNQP+qoAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login/sj.png
// module id = Uu3N
// module chunks = 2